/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import { Form, Table, Input, DatePicker, Typography } from "antd"
import FormSearchFilter from "../../components/FormSearchFilter"
import APIService from "../../service/APIService"
import moment from "moment"

const { RangePicker } = DatePicker
const { Text } = Typography
const dateFormatPicker = "DD-MM-YYYY"

export default function ThongKeTrackingLandingPage() {
  const [dataTable, setDataTable] = useState([])
  const [loading, setLoading] = useState(false)

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0
  })

  const [filter, setFilter] = useState({
    from: "",
    to: "",
    action: "",
    pid: ""
  })

  // columns
  const columns = [
    {
      title: "Time",
      dataIndex: "createdAt",
      render: (val) => val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : ""
    },
    {
      title: "Domain",
      dataIndex: "domain"
    },
    {
      title: "Action",
      dataIndex: "action"
    },
    {
      title: "UTM",
      dataIndex: "pid"
    },
    {
      title: "IP",
      dataIndex: "ip"
    }
  ]

  async function getTrackingLog(page = 1, pageSize = 20) {
    try {
      setLoading(true)

      const res = await APIService.trackingLog(
        filter.from,
        filter.to,
        filter.action,
        filter.pid,
        page,
        pageSize
      )

      setDataTable(res?.data || [])

      setPagination({
        current: res?.page || page,
        pageSize: res?.pageSize || pageSize,
        total: res?.total || 0
      })

    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getTrackingLog(1, pagination.pageSize).then()
  }, [filter])

  return (
    <>
      <FormSearchFilter
        title="Thống kê Tracking"
        initialValues={filter}
        onFormLayoutChange={(value) => {
          // 1. Tạo bản sao filter hiện tại cùng với các giá trị mới từ form
          let newFilter = { ...filter, ...value };

          // 2. Kiểm tra riêng cho trường "time"
          if (value.hasOwnProperty('time')) {
            if (value.time && value.time.length === 2) {
              // Nếu có chọn ngày: Convert sang unix timestamp
              // Dùng startOf và endOf để lấy trọn vẹn dữ liệu trong ngày
              newFilter.from = moment(value.time[0]).startOf('day').unix();
              newFilter.to = moment(value.time[1]).endOf('day').unix();
            } else {
              // Nếu nhấn nút Clear (value.time là null): Reset về rỗng
              newFilter.from = "";
              newFilter.to = "";
            }
          }

          // 3. Cập nhật State
          // Vì bạn đã có useEffect lắng nghe [filter], API sẽ tự động gọi lại
          setFilter(newFilter);
        }}
      >
        <Form.Item label="Time" name="time">
          <RangePicker format={dateFormatPicker} />
        </Form.Item>

        <Form.Item label="Action" name="action">
          <Input placeholder="Search action..." allowClear />
        </Form.Item>

        <Form.Item label="PID" name="pid">
          <Input placeholder="Search PID..." allowClear />
        </Form.Item>
      </FormSearchFilter>

      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={dataTable}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          // Hiển thị bộ chọn pageSize
          showSizeChanger: true,
          // Các lựa chọn số lượng bản ghi (phải là chuỗi)
          pageSizeOptions: ['10', '20', '50', '100', '500'],
          // Văn bản hiển thị (tùy chọn)
          locale: { items_per_page: "/ trang" },
          onChange: (page, pageSize) => {
            // Khi thay đổi pageSize hoặc chuyển trang, gọi lại API
            getTrackingLog(page, pageSize).catch(err => console.error(err));
          },
          // Nếu bạn muốn hiển thị tổng số bản ghi ở góc
          showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} bản ghi`,
        }}
      />
    </>
  )
}